













































































































































































































import axios, { AxiosError } from 'axios';
import { ValidationObserver } from 'vee-validate';
import { Component, Vue, Watch } from 'vue-property-decorator';

import Loading from '@/components/common/Loading.vue';
import UserInfoDialog from '@/components/UserInfoDialog.vue';
import loginUser from '@/store/modules/LoginUserModule';
import { FileUserRole, IPdfInfo, IStampPos, PDFStatus } from '@/types';

interface SnackbarState {
  show: boolean;
  message: string;
  color: 'success' | 'error';
}

interface PdfUser {
  userAccount: string;
  right: FileUserRole;
}

@Component({
  components: {
    Loading,
    UserInfoDialog,
    ValidationObserver,
  },
})
export default class PdfPage extends Vue {
  private address = '';
  //表示用
  private selectedAuthLabel = 'オーナー';
  private authLabel: string[] = ['オーナー', '承認者', '閲覧者'];

  private pdfInfo: IPdfInfo | null = null;
  private currentPage = 1;
  private stampPosList: IStampPos[] = [];
  private readonly thumbnailHeight = 500;
  private dialogVisible = false;
  private confirmDiscardChange = false;
  private sharedUrl = '';
  private thumbnailImg: HTMLImageElement | null = null;
  private stampImg: HTMLImageElement | null = null;
  private zoomRate = 1;
  private selectedStampPos = null;
  private isDrag = false;
  private loading = false;
  private isAlertOverlayShown = false;
  private userInfoDialog = false;

  private readonly frameWidth = 1;
  private readonly frameWidthHighlighted = 3.5;
  private readonly frameColor = '#00000099';
  private readonly frameColorHighlighted = '#e9cf25';

  private snackbar: SnackbarState = {
    show: false,
    message: '',
    color: 'success',
  };

  private get uuid(): string | null {
    if (this.pdfInfo != null && this.pdfInfo.uuid != null) {
      return this.pdfInfo.uuid;
    } else {
      return null;
    }
  }

  private get pageCount(): number | null {
    if (this.pdfInfo != null && this.pdfInfo.pageCount != null) {
      return this.pdfInfo.pageCount;
    } else {
      return null;
    }
  }

  private get fileName(): string | null {
    if (this.pdfInfo != null && this.pdfInfo.fileName != null) {
      return this.pdfInfo.fileName;
    } else {
      return null;
    }
  }

  private get thumbnailUrl(): string | null {
    if (this.uuid != null) {
      return '/pdf/thumbnail/' + this.uuid + '/' + this.currentPage;
    } else {
      return null;
    }
  }

  // 押印できるかどうか
  // uuidが付与され名前の登録が完了しており、各imageのloadも完了している状態でtrueを返す
  private get isReadyToStamp(): boolean {
    return (
      this.uuid != null &&
      this.hasUserName &&
      this.thumbnailImg != null &&
      this.stampImg != null
    );
  }

  private get stampUrl() {
    return '/stamp?' + this.userName;
  }

  private get hasUserName(): boolean {
    return (
      loginUser.loginUser?.name != null && loginUser.loginUser.name.length > 0
    );
  }

  private get userName(): string | null {
    return loginUser.loginUser?.name ?? null;
  }

  // 現在のファイルに対する権限
  private get right(): FileUserRole {
    const loginAcount = loginUser.loginUser?.userAccount;
    const info = this.pdfInfo;
    if (loginAcount == null || info == null) {
      return 'NONE';
    } else if (info.ownerList && info.ownerList.includes(loginAcount)) {
      return 'OWNER';
    } else if (info.approverList && info.approverList.includes(loginAcount)) {
      return 'APPROVER';
    } else if (info.viewerList && info.viewerList.includes(loginAcount)) {
      return 'VIEWER';
    } else if (info.defaultUserRole != null) {
      // いずれにも含まれていなかったらデフォルトにする
      return info.defaultUserRole;
    } else {
      // デフォルトすら取得できていなかったり設定されていなかったらNONEにする
      // (恐らくないと思うが)
      return 'NONE';
    }
  }

  // 現在のファイルのステータス
  private get fileStatus(): PDFStatus {
    return this.pdfInfo?.status ?? 'CLOSED';
  }

  private get pdfUserList(): PdfUser[] {
    const ret: PdfUser[] = [];
    const info = this.pdfInfo;
    if (info != null) {
      for (const owner of info.ownerList) {
        ret.push({ userAccount: owner, right: 'OWNER' });
      }
      for (const approver of info.approverList) {
        ret.push({ userAccount: approver, right: 'APPROVER' });
      }
      for (const viewer of info.viewerList) {
        ret.push({ userAccount: viewer, right: 'VIEWER' });
      }
    }
    return ret;
  }

  @Watch('thumbnailUrl')
  private onThumbnailUrlChanged(newVal: string | null) {
    if (newVal == null) {
      return;
    }
    this.reloadThumbnail(newVal);
  }

  @Watch('userName')
  private onUserNameChanged(newVal: string | null) {
    if (!this.hasUserName) {
      return;
    }
    this.stampImg = new Image();
    this.stampImg.src = this.stampUrl;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    this.stampImg.onload = () => {
      if (vm.thumbnailUrl != null) {
        vm.reloadThumbnail(vm.thumbnailUrl);
      }
    };
  }

  private showAlertOverlayIfNeeded() {
    // console.log('showAlertOverlayIfNeeded');
    if (
      !this.hasUserName &&
      (this.right == 'APPROVER' || this.right == 'OWNER') &&
      this.fileStatus != 'CLOSED'
    ) {
      // 押印権限があり、まだ締まっていないのに名前が登録されていない時
      this.isAlertOverlayShown = true;
      return;
    }
  }

  private hideAlertOverlay() {
    // console.log('hideAlertOverlay');
    this.isAlertOverlayShown = false;
  }

  private mouseLeaveFromThumbnail(event: MouseEvent) {
    console.log('mouseLeaveFromThumbnail');
    this.mouseMove(event);
  }

  private mouseMove(event: MouseEvent) {
    if (this.right != 'APPROVER' && this.right != 'OWNER') {
      // 押印権限無しの人なら、何もしない
      return;
    }
    if (this.fileStatus == 'CLOSED') {
      // もう締まっていたら、何もしない
      return;
    }
    if (this.thumbnailImg != null && this.stampImg != null) {
      const canvas: any = this.$refs.thumbnail;
      const ctx = canvas.getContext('2d');
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      ctx.drawImage(this.thumbnailImg, 0, 0, canvasWidth, canvasHeight);
      // 印鑑画像が完全に描画できる位置の場合のみ描画する
      // 陰影画像が切れた状態を許可しない
      if (
        this.canDrawEntireStampImage(
          event.offsetX,
          event.offsetY,
          this.stampImg.width,
          this.stampImg.height,
          canvas.width,
          canvas.height
        )
      ) {
        this.drawStamp(ctx, event.offsetX, event.offsetY);
      }
      this.drawStampPosList(ctx, this.stampPosList, canvasHeight);
    }
  }

  // マウスの位置が、印鑑画像が完全に描画できる位置かどうかを返す
  private canDrawEntireStampImage(
    mouseX: number,
    mouseY: number,
    stampWidth: number,
    stampHeight: number,
    canvasWidth: number,
    canvasHeight: number
  ): boolean {
    if (
      mouseX - (stampWidth * this.zoomRate) / 2 < 0 ||
      mouseX + (stampWidth * this.zoomRate) / 2 > canvasWidth
    ) {
      return false;
    }
    if (
      mouseY - (stampHeight * this.zoomRate) / 2 < 0 ||
      mouseY + (stampHeight * this.zoomRate) / 2 > canvasHeight
    ) {
      return false;
    }
    return true;
  }

  private drawStampPosList(
    ctx: any,
    stampPosList: IStampPos[],
    thumbnailHeight: number,
    highlightIndex?: number // 指定されたindexの要素は黄枠表示する
  ) {
    stampPosList.forEach((stampPos, i) => {
      if (stampPos.page !== this.currentPage) {
        return;
      }
      this.drawStamp(
        ctx,
        (stampPos.offsetX * thumbnailHeight) / 100,
        (stampPos.offsetY * thumbnailHeight) / 100,
        i === highlightIndex
      );
    });
  }

  private drawStamp(ctx: any, x: number, y: number, highlight?: boolean) {
    if (this.stampImg != null) {
      const widthSize = this.stampImg.width * this.zoomRate;
      const heightSize = this.stampImg.height * this.zoomRate;
      ctx.drawImage(
        this.stampImg,
        x - widthSize / 2,
        y - heightSize / 2,
        widthSize,
        heightSize
      );

      // 保存されていないことがわかるように枠で囲う
      ctx.strokeStyle = highlight
        ? this.frameColorHighlighted
        : this.frameColor;
      ctx.lineWidth = highlight ? this.frameWidthHighlighted : this.frameWidth;
      ctx.strokeRect(
        x - widthSize / 2,
        y - heightSize / 2,
        widthSize,
        heightSize
      );
    }
  }

  private getStampPosListItemText(i: number, stampPos: IStampPos): string {
    // 座標情報はいらないだろうがとりあえず表示しておく
    return `署名${i + 1}\t(ページ${stampPos.page})`;
  }

  private reloadThumbnail(url: string) {
    this.loading = true;
    const canvas: any = this.$refs.thumbnail;
    const ctx = canvas.getContext('2d');
    this.thumbnailImg = new Image();
    this.thumbnailImg.src =
      url +
      '?' +
      Math.random()
        .toString(16)
        .substring(2);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    this.thumbnailImg.onload = function() {
      if (vm.thumbnailImg) {
        console.log(
          'thumbnail loaded',
          vm.thumbnailImg.width,
          vm.thumbnailImg.height
        );
        canvas.width =
          (vm.thumbnailImg.width / vm.thumbnailImg.height) * canvas.height;
        vm.zoomRate = canvas.height / vm.thumbnailImg.height;
        ctx.drawImage(vm.thumbnailImg, 0, 0, canvas.width, canvas.height);
        // クリックした場所
        vm.drawStampPosList(ctx, vm.stampPosList, canvas.height);
        vm.loading = false;
      }
    };
    this.thumbnailImg.onerror = () => {
      console.log('thumbnailImg onerror');
      vm.loading = false;
    };
  }

  private getRoleLabel(role: FileUserRole): string {
    switch (role) {
      case 'OWNER':
        return 'オーナー';
      case 'APPROVER':
        return '承認者';
      case 'VIEWER':
        return '閲覧者';
      default:
        return '権限なし';
    }
  }

  // debug出力用
  private getUserListFromPdfInfo(key: FileUserRole): string[] | null {
    const info = this.pdfInfo;
    if (info != null) {
      switch (key) {
        case 'OWNER':
          return info.ownerList;
        case 'APPROVER':
          return info.approverList;
        case 'VIEWER':
          return info.viewerList;
        default:
          break;
      }
    }
    return null;
  }

  // debug出力用
  private getSignerListFromPdfInfo(): string[] | null {
    if (this.pdfInfo) {
      const ret: string[] = [];
      const sigs = this.pdfInfo.signatureList;
      for (const sig of sigs) {
        ret.push(sig.userAccount);
      }
      return ret;
    }
    return null;
  }

  private async created() {
    if (this.$route.query.id) {
      const uuid = this.$route.query.id.toString();
      this.loading = true;
      let res;
      try {
        res = await axios.get(`/api/pdf/${uuid}/info`);
        this.pdfInfo = {
          uuid: res.data.uuid,
          pageCount: res.data.pageCount,
          fileName: res.data.fileName,
          createUserAccount: res.data.createUserAccount,
          status: res.data.status,
          defaultUserRole: res.data.defaultUserRole,
          viewerList: res.data.viewerList,
          approverList: res.data.approverList,
          ownerList: res.data.ownerList,
          signatureList: res.data.signatureList,
        };
      } catch (e) {
        console.log(`created: error=${e}`);
      }

      this.loading = false;
      if (!res || res.data === '') {
        this.showSnackbar('PDFファイルの読み込みに失敗しました。', 'error');
        return;
      }
    }
    if (this.hasUserName) {
      this.stampImg = new Image();
      this.stampImg.src = this.stampUrl;
    }
  }

  private updateDrug(isDrug: boolean) {
    this.isDrag = isDrug;
  }

  private pickFile() {
    const ref: any = this.$refs.file;
    ref.click();
  }

  private async onFileDropped(event: DragEvent) {
    console.log(`onFileDropped: event=${event}`);
    this.isDrag = false;
    if (event.dataTransfer && event.dataTransfer.files) {
      this.updatePDF(event.dataTransfer.files[0]);
    }
  }

  private async onFilePicked(event: Event) {
    console.log(`onFilePicked: e=${event}`);
    const target = event.target as HTMLInputElement;
    if (target.files) {
      this.updatePDF(target.files[0]);
    }
  }

  // uploadPDFFileを呼び出し、uploadに成功したらPDFの表示を更新する
  private async updatePDF(file: File): Promise<void> {
    console.log(`updatePDF: file=${file}`);

    this.loading = true;
    try {
      const result = await this.uploadPDFFile(file);
      this.pdfInfo = result;
      this.currentPage = 1;
      this.stampPosList.length = 0;
      this.$router.replace({
        name: 'pdf',
        query: {
          id: this.uuid,
        },
      });
    } catch (e) {
      // if (axios.isAxiosError(e)) {
      //   console.error(`axios error: ${e}`);
      // } else {
      //   console.error(`error: ${e}`);
      // }
      console.log(`error: ${e}`);
      this.showSnackbar('PDFファイルのアップロードに失敗しました。', 'error');
    } finally {
      this.loading = false;
    }
  }

  private async uploadPDFFile(file: File): Promise<IPdfInfo> {
    const formData = new FormData();
    formData.append('file', file);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    const resp = await axios.post('/api/pdf', formData, config);
    if (!resp || !resp.data) {
      throw new Error('invalid response');
    }
    return resp.data;
  }

  private showSnackbar(message: string, color: 'success' | 'error') {
    this.snackbar.show = true;
    this.snackbar.message = message;
    this.snackbar.color = color;
  }

  private updateStampHighlight(i: number, highlight: boolean) {
    if (!this.stampImg || !this.thumbnailImg) {
      return;
    }
    if (!this.stampPosList || i >= this.stampPosList.length) {
      return;
    }

    const canvas = this.$refs.thumbnail as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.drawImage(this.thumbnailImg, 0, 0, canvas.width, canvas.height);

    // 選択された要素を黄枠表示
    let highlightIndex: number | undefined;
    if (highlight) {
      highlightIndex = i;
    }
    this.drawStampPosList(
      ctx,
      this.stampPosList,
      canvas.height,
      highlightIndex
    );
  }

  private async onStampPosListItemClicked(i: number) {
    if (!this.stampImg || !this.thumbnailImg) {
      return;
    }
    if (!this.stampPosList || i >= this.stampPosList.length) {
      return;
    }
    console.log(`${i} ===`);
    this.stampPosList.splice(i, 1);

    const canvas = this.$refs.thumbnail as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.drawImage(this.thumbnailImg, 0, 0, canvas.width, canvas.height);

    this.drawStampPosList(ctx, this.stampPosList, canvas.height);
  }

  private async onThumbnailClick(event: MouseEvent) {
    if (this.right != 'APPROVER' && this.right != 'OWNER') {
      // 押印権限無しの人なら、何もしない
      return;
    }
    if (this.fileStatus == 'CLOSED') {
      // もう締まっていたら、何もしない
      return;
    }
    if (this.thumbnailImg == null || this.stampImg == null) {
      console.log('cannot draw entire stamp');
      return;
    }

    const canvas: any = this.$refs.thumbnail;
    if (
      !this.canDrawEntireStampImage(
        event.offsetX,
        event.offsetY,
        this.stampImg.width,
        this.stampImg.height,
        canvas.width,
        canvas.height
      )
    ) {
      return;
    }

    this.stampPosList.push({
      page: this.currentPage,
      offsetX: (event.offsetX / this.thumbnailHeight) * 100,
      offsetY: (event.offsetY / this.thumbnailHeight) * 100,
    });
  }

  private onCopySharedUrl() {
    if (this.sharedUrl) {
      const field: any = this.$refs.sharedUrl;
      const elem: HTMLInputElement = field.$refs.input;
      elem.select();
      document.execCommand('copy');
      this.showSnackbar('URLをコピーしました。', 'success');
    }
  }

  private async onSaveSignature() {
    this.loading = true;
    const res = await axios
      .post(`/api/pdf/${this.uuid}/signature`, this.stampPosList)
      .catch((error: AxiosError) => {
        console.error(error);
        return null;
      });
    this.loading = false;
    if (res) {
      this.stampPosList.splice(0);
      if (this.thumbnailUrl) {
        this.reloadThumbnail(this.thumbnailUrl);
      }
      return true;
    } else {
      return false;
    }
  }

  private async onDownloadSignedPDF() {
    if (this.stampPosList.length > 0) {
      if (!(await this.onSaveSignature())) {
        return;
      }
    }
    location.href = '/pdf/signed/' + this.uuid;
  }

  private confirmDiscard() {
    if (this.stampPosList.length === 0) {
      this.reset();
      return;
    }
    this.confirmDiscardChange = true;
  }

  private reset() {
    this.confirmDiscardChange = false;
    this.pdfInfo = null;
    this.currentPage = 1;
    this.stampPosList.splice(0);
    this.$router.push({ name: 'pdf' });
  }

  private onShare() {
    this.sharedUrl =
      location.href.substring(0, location.href.indexOf('?')) +
      '?id=' +
      this.uuid;
    this.dialogVisible = true;
  }

  private onChangeUserRole(event: Event, i: number) {
    console.log(event.toString() + ', ' + i);
    // TODO: ローカルな、ユーザー&権限のリストを持っておき、表示上の情報に従って逐次更新する。
    // onConfirmUserRole()の中で、実際のPDFに対してそのリストを使って変更処理を行うようにする。
    return;
  }

  private onConfirmUserRole() {
    console.log('TODO: ユーザー権限変更処理');
    return;
  }

  private async onAddUserAddress() {
    if (!this.pdfInfo) {
      return;
    }

    // UI上で選択されているラベルに従って入力されたaddressをユーザーリストに追加
    if (this.selectedAuthLabel == this.authLabel[0]) {
      this.pdfInfo.ownerList.push(this.address);
    } else if (this.selectedAuthLabel == this.authLabel[1]) {
      this.pdfInfo.approverList.push(this.address);
    } else if (this.selectedAuthLabel == this.authLabel[2]) {
      this.pdfInfo.viewerList.push(this.address);
    } else {
      // ないはず
      return;
    }

    try {
      const res = await axios.post(`/api/pdf/${this.uuid}/info`, this.pdfInfo);
      console.log('status: ' + res.status);
      // TODO: 表示更新
    } catch (e) {
      console.log(`onAddUserAddress: error=${e}`);
    }
  }

  private async onConclude() {
    try {
      // TODO: 確認のダイアログ程度は挟むべき
      const res = await axios.post(`/api/pdf/${this.uuid}/close`);
      console.log('status: ' + res.status);
      // TODO: 表示更新
    } catch (e) {
      console.log(`onConclude: error=${e}`);
    }
  }
}
